import { useEffect, StrictMode } from 'react'
import i18n from 'i18next'
import { BrowserRouter, Routes, Route } from "react-router-dom"
import { Provider } from 'react-redux'
import store from './store'
import { AuthProvider } from './components/auth/useAuth'
import PrivateAdminRouter from './routers/PrivateAdminRouter'
import AdminRouter from './routers/AdminRouter'
import PrivateClerkRouter from './routers/PrivateClerkRouter'
import PrivateCommercialRouter from './routers/PrivateCommercialRouter'
import ClerkRouter from './routers/ClerkRouter'
import CommercialRouter from './routers/CommercialRouter'
import PublicRouter from './routers/PublicRouter'

const t = i18n.t.bind(i18n)

export default function App() {
    useEffect(() => {
        const handleWheel = (event: WheelEvent) => {
            const target = event.target as HTMLInputElement | null;
            if (target?.type === "number" && target === document.activeElement) {
            event.preventDefault();
            }
        };

        window.addEventListener("wheel", handleWheel, { passive: false });
        return () => {
            window.removeEventListener("wheel", handleWheel as EventListener);
        };
    }, []);

    return (
	    <Provider store={store}>
            <StrictMode>
                <BrowserRouter>
                    <AuthProvider>
                        <Routes>
                            <Route path={`/${t("url.admin")}/*`} element={<PrivateAdminRouter><AdminRouter /></PrivateAdminRouter>} />
                            <Route path={`/${t("url.clerk")}/*`} element={<PrivateClerkRouter><ClerkRouter /></PrivateClerkRouter>} />
                            <Route path={`/${t("url.commercial")}/*`} element={<PrivateCommercialRouter><CommercialRouter /></PrivateCommercialRouter>} />
                            <Route path="/*" element={<PublicRouter />}/>
                        </Routes>
                    </AuthProvider>
                </BrowserRouter>
            </StrictMode>
        </Provider>
    )
}